// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__D0ef1","loaderOuter":"PageOverlayLoader_loaderOuter__3kqhY"};